import React from "react";
import InstrumentSearch from "./InstrumentSearch";
import {instrumentWith} from "../models";
import { RECOMMENDABLE_TYPE } from "../constants";

const instrumentStyles = {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
};

function renderRecommendable(recommendable) {
    if (recommendable.userProvided) {
        const userProvidedTopLine = <span>{recommendable["name"]}</span>;
        const userProvidedBottomLine = <span>{recommendable.recommendableType}</span>
        return <RenderedRecommendable topLine={userProvidedTopLine} bottomLine={userProvidedBottomLine}/>;
    }

    switch (recommendable.recommendableType) {
        case RECOMMENDABLE_TYPE.BOND:
            const bondTopLine = <span>{recommendable["bloomberg_ticker"]}</span>;
            const bondBottomLine = <span>{recommendable["isin"]}</span>;
            return <RenderedRecommendable topLine={bondTopLine} bottomLine={bondBottomLine}/>;
        case RECOMMENDABLE_TYPE.EQUITY:
            const equityTopLine = <span>{recommendable["bloomberg"]}</span>;
            const equityBottomLine = <span>{recommendable["name"]}</span>;
            return <RenderedRecommendable topLine={equityTopLine} bottomLine={equityBottomLine}/>;
        case RECOMMENDABLE_TYPE.FX_PAIR:
            const fxPairTopLine = <span>{recommendable["pair"]}</span>;
            return <RenderedRecommendable topLine={fxPairTopLine}/>;
        case RECOMMENDABLE_TYPE.ISSUER:
            const issuerTopLine = <span>{recommendable["bloomberg_ticker"]}, {recommendable["name"]}</span>;
            return <RenderedRecommendable topLine={issuerTopLine}/>;
        case RECOMMENDABLE_TYPE.SOVEREIGNTY:
            const sovereigntyTopLine = <span>{recommendable["ticker"]}, {recommendable["name"]}</span>;
            return <RenderedRecommendable topLine={sovereigntyTopLine}/>;
        case RECOMMENDABLE_TYPE.INTEREST_RATE_FUTURE:
            const interestRateTopLine = <span>{recommendable["base_bloomberg_ticker"]}, {recommendable["name"]}</span>;
            const interestRateBottomLine = <span>{recommendable["exchange"]}, {recommendable["base_exchange_ticker"]}</span>;
            return <RenderedRecommendable topLine={interestRateTopLine} bottomLine={interestRateBottomLine}/>;
    }
}

const RenderedRecommendable = (props) => (
    <span>
        {props.topLine}<br/>
        { props.bottomLine ? <small className="x-name" style={{ color: '#777' }}>{props.bottomLine}</small> : null }
    </span>
);

const InstrumentChoice = (props) => (
    <div style={{width: 165}}>
        {props.value.instrumentId ?
            <div style={{position: "relative"}}>
                <div className="x-chosen-instrument" style={instrumentStyles}>{renderRecommendable(props.value.recommendable)}</div>
                <input type="button" className="x-change button-as-link" onClick={() =>  props.onChange(instrumentWith())} value="change" />
            </div> :
            <InstrumentSearch {...props} value={props.value.name} />
        }
    </div>
);

InstrumentChoice.propTypes = {
    value: React.PropTypes.object
};
InstrumentChoice.defaultProps = {
    value: {}
};

export default InstrumentChoice;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/components/InstrumentChoice.js
 **/